import * as types from 'constants/ActionTypes';
import { MODELS_FILTER_URL, MODELS_SEARCH_FIND_BY_ID_URL, MODELS_URL } from 'constants/ApiConstants';

// MODELS
export const fetchModels = (links, params) => ({
  type: types.FETCH_MODELS_REQUEST,
  links,
  params,
});

export const fetchModelsFailure = error => ({
  type: types.FETCH_MODELS_FAILURE,
  error,
});

export const fetchModelsSuccess = (models, page, links) => ({
  type: types.FETCH_MODELS_SUCCESS,
  models,
  page,
  links,
});

export const toggleValidModels = () => ({
  type: types.TOGGLE_VALID_MODELS,
});

// MODELS SELECT
export const fetchModelsSelect = params => ({
  type: types.FETCH_MODELS_SELECT_REQUEST,
  payload: {
    request: {
      method: 'GET',
      url: MODELS_FILTER_URL,
      params,
    },
  },
});

export const fetchModelsSelectNextPage = () => ({
  type: types.FETCH_MODELS_SELECT_NEXT_PAGE_REQUEST,
});

export const fetchModelsSelectFailure = error => ({
  type: types.FETCH_MODELS_SELECT_FAILURE,
  error,
});

export const fetchModelsSelectSuccess = models => ({
  type: types.FETCH_MODELS_SELECT_SUCCESS,
  models,
});

export const cleanModelsSelect = () => ({
  type: types.CLEAN_MODELS_SELECT,
});

// FILTER
export const setModelFilter = payload => ({
  type: types.SET_MODEL_FILTER,
  payload,
});

export const cleanModelFilter = () => ({
  type: types.CLEAN_MODEL_FILTER,
});

// MODEL
export const fetchModel = params => ({
  type: types.FETCH_MODEL_REQUEST,
  payload: {
    request: {
      method: 'GET',
      url: MODELS_SEARCH_FIND_BY_ID_URL,
      params,
    },
  },
});

export const fetchModelFailure = error => ({
  type: types.FETCH_MODEL_FAILURE,
  error,
});

export const fetchModelSuccess = model => ({
  type: types.FETCH_MODEL_SUCCESS,
  model,
});

// UPLOAD FOR UPDATE
export const uploadModelRequest = payload => ({
  type: types.UPLOAD_MODEL_REQUEST,
  payload,
});

export const uploadModelsRequest = ({ models, length }) => ({
  type: types.UPLOAD_MODELS_REQUEST,
  payload: { models, length },
});

export const uploadModelsSuccess = () => ({
  type: types.UPLOAD_MODELS_SUCCESS,
});

export const uploadModelsFailure = error => ({
  type: types.UPLOAD_MODELS_FAILURE,
  payload: { error },
});

// UPDATE A MODEL
export const updateModelRequest = ({ model }) => ({
  type: types.UPDATE_MODEL_REQUEST,
  payload: {
    request: {
      method: 'PATCH',
      url: `${MODELS_URL}/${model.id}`,
      data: model,
    },
  },
});

export const updateModelSuccess = model => ({
  type: types.UPDATE_MODEL_SUCCESS,
  payload: model,
});

export const updateModelFailure = payload => ({
  type: types.UPDATE_MODEL_FAILURE,
  error: true,
  payload,
});

// EDIT A MODEL
export const openUpdateModal = ({ modelId }) => ({
  type: types.OPEN_UPDATE_MODAL,
  payload: { modelId },
});

export const closeUpdateModal = () => ({
  type: types.CLOSE_UPDATE_MODAL,
});

export const cleanModelsDashboard = () => ({
  type: types.CLEAN_MODELS_DASHBOARD,
});
